import PropTypes from "prop-types";
import {
  ComposedChart as REComposedChart,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Bar,
  Cell,
  LabelList,
  Tooltip,
} from "recharts";

export const ComposedChart = ({
  data,
  xAxisProps,
  yAxisProps,
  composedChartProps,
  cartesianGridProps,
  tooltipContent,
}) => {
  return (
    <ResponsiveContainer>
      <REComposedChart data={data} {...composedChartProps}>
        {xAxisProps && <XAxis {...xAxisProps} />}

        {yAxisProps && <YAxis {...yAxisProps} />}

        {cartesianGridProps && <CartesianGrid {...cartesianGridProps} />}

        {/* tooltip */}
        {tooltipContent && <Tooltip content={tooltipContent} />}

        <Bar dataKey="value" scale="point" minPointSize={5}>
          <LabelList
            dataKey="text"
            position="insideBottom"
            angle={270}
            offset={50}
            fill="white"
          />
          {data.map((entry) => (
            <Cell key={`cell-${entry.name}`} fill={entry.color} />
          ))}
        </Bar>
      </REComposedChart>
    </ResponsiveContainer>
  );
};

ComposedChart.propTypes = {
  data: PropTypes.array,
  xAxisProps: PropTypes.object,
  yAxisProps: PropTypes.object,
  composedChartProps: PropTypes.object,
  cartesianGridProps: PropTypes.object,
  tooltipContent: PropTypes.func,
};

ComposedChart.defaultProps = {
  data: [],
};
